import { setDefaultField } from 'Actions/ConfigActions';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { dotOnlyDateWithDayName } from '../../../util/DateUtils';
import { putFieldDefault } from '../../../api/endpoints/User';
import icPencil1 from 'Assets/img/sidebar/ic_blue_pencil.png';
import icPencil2 from 'Assets/img/sidebar/ic_blue_pencil@2x.png';
import icPencil3 from 'Assets/img/sidebar/ic_blue_pencil@3x.png';
import { collapsedFieldSidebarAction } from 'Actions/AppSettingsActions';
import { getImageSet } from 'Util/DataUtils';
import { useError } from 'Api/hooks/useError';
import HighlightKeyword from 'Components/Views/HighlightKeyword';

const icPencil = getImageSet([icPencil1, icPencil2, icPencil3]);

const FieldItem = ({ field, openUpdateField, isAll, searchText, openCreateField }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { defaultField } = useSelector(state => state.config);
  const isDefault = field._id === defaultField._id;
  const { locale } = useSelector(state => state.settings.locale);
  const { showErrorPopup } = useError();
  const { newField } = useSelector(state => state.noty);

  const handleFieldClick = async () => {
    if (defaultField.isFirstField) {
      openCreateField();
      return;
    }
    if (isAll) navigate('/admin/dashboard/field', { replace: true });
    dispatch(collapsedFieldSidebarAction(true));
    if (isDefault) return;
    dispatch(setDefaultField(field));
    try {
      const result = await putFieldDefault(field._id);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 정규표현식 특수문자를 이스케이프하는 함수
  const escapeRegExp = string => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const highlightSearchKeyword = text => {
    if (!searchText) return text;

    const escapedSearchText = escapeRegExp(searchText);
    const parts = text.split(new RegExp(`(${escapedSearchText})`, 'gi'));
    return parts.map((part, i) => {
      if (part.toLowerCase() === searchText.toLowerCase()) {
        return (
          <span key={i} style={{ color: '#0567F9', fontWeight: 700 }}>
            {part}
          </span>
        );
      }
      return <span key={i}>{part}</span>;
    });
  };

  const isNewField = useMemo(() => {
    if (field._id === defaultField._id) return false;
    return newField && Object.keys(newField).length > 0 && Object.keys(newField).some(fieldId => fieldId === field._id);
  }, [newField, defaultField._id, field._id]);

  return (
    <div className={`field-sidebar-list-item cursor-pointer ${!isAll && isDefault && 'default-item'}`} onClick={handleFieldClick}>
      <div className="item-name-wrapper">
        <div className="item-name">
          {isNewField && <div className="item-name-new" />}
          <div className="item-name-text">
            <HighlightKeyword text={field.name} searchText={searchText} highlightStyle={{ color: '#0567F9', fontWeight: 700 }} />
          </div>
        </div>
        {!isAll && isDefault && (
          <img
            {...icPencil}
            alt="pencil"
            onClick={e => {
              e.stopPropagation();
              openUpdateField(field._id);
            }}
          />
        )}
      </div>
      <div className="item-address">{highlightSearchKeyword(`${field.address || ''} ${field.address2 || ''}`)}</div>
      {(field.dateConstructStart || field.dateConstructEnd) && (
        <div className="item-date">{`${dotOnlyDateWithDayName(field.dateConstructStart, locale)} ~ ${dotOnlyDateWithDayName(field.dateConstructEnd, locale)}`}</div>
      )}
    </div>
  );
};

export default FieldItem;
